// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__zhT2n","col":"CardReaderDesc_col__2QQW5","label":"CardReaderDesc_label__WQ2Cw"};